import {createSelector} from 'reselect'

const getSupportState = state => state.support

export const showSupportQuestionButton = createSelector(
    getSupportState,
    (support) => support.showSupportQuestionButton
)

export const isSupportFormShown = createSelector(
    getSupportState,
    (support) => support.isShown
)

export const isLoading = createSelector(
    getSupportState,
    (support) => support.loading
)

export const getSupportFormPosition = createSelector(
    getSupportState,
    (support) => support.position
)

export const getSupportFormPositionStrategy = createSelector(
    getSupportState,
    (support) => support.positionStrategy
)

export const getSupportFormMode = createSelector(
    getSupportState,
    (support) => support.mode
)

export const getSupportText = createSelector(
    getSupportState,
    (support) => support.text
)

export const getSupportAttachmentId = createSelector(
    getSupportState,
    (support) => support.attachmentId
)

export const getSupportAttachmentName = createSelector(
    getSupportState,
    (support) => support.attachmentName
)

export const getSupportEmail = createSelector(
    getSupportState,
    (support) => support.email
)

export const getPopupInfo = createSelector(
    getSupportState,
    (support) => {
        return {
            isShown: support.isShown,
            mode: support.mode,
            text: support.text,
            attachmentId: support.attachmentId,
            attachmentName: support.attachmentName,
            email: support.email,
            position: support.position,
            positionStrategy: support.positionStrategy,
        }
    }
)



// WEBPACK FOOTER //
// ./web/js/support/supportForm/selectors.js